export const RECEIVE_ASSIGNMENTS = 'RECEIVE_ASSIGNMENTS';
export const ADD_ASSIGNMENT = 'ADD_ASSIGNMENT';
export const DELETE_ASSIGNMENT = 'DELETE_ASSIGNMENT';
export const UPDATE_ASSIGNMENT = 'UPDATE_ASSIGNMENT';
export const LOADING_ASSIGNMENTS = 'LOADING_ASSIGNMENTS';

// Not for Redux
export const ASSIGNED_ROLE = 0;
export const REVIEWING_ROLE = 1;

export const IMPROVING_ARTICLE = 'improving_article';
export const NEW_ARTICLE = 'new_article';
export const REVIEWING_ARTICLE = 'reviewing_article';
